<template>
  <div>
    <div class="vip-type-list" style="font-size:16px">
      <span>{{this.$route.query.shopName}}  ：优惠折扣</span>
      <div style="display:flex;align-items:center;">
        <div class="date-box">
          <div class="box-left" @click="changeSubNum(false)">＜</div>
          <div>{{yearMonthArr[subNum]}}</div>
          <div class="box-right" @click="changeSubNum(true)">＞</div>
        </div>
        <el-button type="success" @click="this.$router.go(-1)">返回</el-button>
      </div>
    </div>
    <main  style="margin:0 20px">
      <div class="vip-type-list" style="font-size:14px">
        <span style="font-size:14px">
优惠折扣汇总：{{(Number(disMoney)).toFixed(2)}}  （ 会员优惠：{{(Number(discountMoney)).toFixed(2)}}    免单：{{(Number(freeMoney)).toFixed(2)}}    扣减：{{(Number(reduceMoney)).toFixed(2)}}    积分抵扣：{{(Number(integralDeduct)).toFixed(2)}}    代金券消费：{{(Number(voucherDeduct)).toFixed(2)}}  ）</span>
      </div>
      <div style="padding-top:20px">
        <el-table 
          :data="dataOne" 
          border  
          stripe style="width: 100%"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
        >
          <el-table-column prop="dutyStartTime" label="班次开始时间" width="140"/>
          <el-table-column prop="dutyEndTime" label="班次结束时间"  width="140"/>
          <el-table-column label="会员优惠" >
            <template #default="props">
              <span>{{(Number(props.row.discountMoney)).toFixed(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="freeMoney" label="免单" />
          <el-table-column prop="reduceMoney" label="扣减" />
          <el-table-column prop="integralDeduct" label="积分抵扣" />
          <el-table-column prop="voucherDeduct" label="代金券消费" />
          <el-table-column label="合计" >
            <template #default="props">
              <span>{{(Number(props.row.total)).toFixed(2)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </main>
        <Print rul='report/monthReportStatistics.json' :add='"&yearMonth="+yearMonthArr[subNum]+"&chainShopId="+this.$route.query.shopId+"&name="+"discount"' />
  </div>
</template>

<script>
import {ref} from 'vue'
import {postData} from"@a"
import {useRoute} from 'vue-router'
export default {
  setup(){
    const route = useRoute()
    let options1 = ref([
      {value:'全部',label:'全部'},
      {value:'茶类系列',label:'茶类系列'},
      {value:'副品系列',label:'副品系列'},
      {value:'烟酒',label:'烟酒'}
    ])
    let options2 = ref([
      {value:'全部',label:'全部'},
      {value:'有',label:'有'},
      {value:'无',label:'无'}
    ])
    let options3 = ref([
      {value:'全部',label:'全部'}
    ])
    let input1 = ref('')
    let value1 = ref('全部')
    let value2 = ref('全部')
    let value3 = ref('全部')
    const dataOne = ref([
    ])

    const headerStyle = ()=>{
      let style  = {}
      style.color = '#333333'
      style['font-size'] = '14px'
      style['font-weight'] = '400'
      style['padding-left'] = '20px'
      style['background-color'] = '#D7D7D7'
      return style
    }
    const cellStyle = ()=>{
      let style  = {}
      style.color = '#000'
      style['font-size'] = '14px'
      style['padding-left'] = '20px'
      style['font-weight'] = '500'
      return style
    }
        let newDate = new Date().getMonth()+1
    let newYear = new Date().getFullYear()
    let yearMonthArr = ref([])
    for(let i = 0;i<12;i++){
      if(newDate-i === 0){
        newDate = 13
        newYear -=1
      }
      let data = ''
      if(newDate-i>0){
        data = newYear + '-' + (newDate-i>9?newDate-i:'0'+(newDate-i))
      }else{
        let j = i - newDate
        data = newYear + '-' + ((newDate-j)>9?(newDate-j):'0'+(newDate-j))
      }
      yearMonthArr.value.unshift(data)
    }
    let subNum = ref(yearMonthArr.value.length-1)
    if(route.query.time){
      for(let i = 0;i<yearMonthArr.value.length;i++){
        if(route.query.time === yearMonthArr.value[i]){
          subNum.value = i
          break
        }
      }
    }
    const changeSubNum = (val)=>{
      console.log(val,yearMonthArr.value,subNum.value)
      if(val && subNum.value<yearMonthArr.value.length-1){
        subNum.value+=1
        infoData()
      }else if(!val && subNum.value>1){
        subNum.value -=1
        infoData()
      }
    }
    let discountMoney = ref(0)
    let disMoney = ref(0)
    let freeMoney = ref(0)
    let reduceMoney = ref(0)
    let integralDeduct = ref(0)
    let voucherDeduct =ref(0)
    const infoData = async()=>{
      dataOne.value = []
      try{
        let param = {
          yearMonth:yearMonthArr.value[subNum.value],
          chainShopId:route.query.shopId
        }
        // 会员优惠：{{discountMoney}}    免单：{{freeMoney}}    
        //扣减：{{reduceMoney}}    积分抵扣：{{integralDeduct}}    代金券消费{{voucherDeduct}}
        let res = await postData('shop/monthReportStatistics.json',param)
          discountMoney.value = 0
          freeMoney.value = 0
          reduceMoney.value = 0
          integralDeduct.value = 0
          voucherDeduct.value = 0
          disMoney.value = 0
        for(let i = 0;i<res.data.length;i++){
          discountMoney.value += Number(res.data[i].discountMoney)
          freeMoney.value += Number(res.data[i].freeMoney)
          reduceMoney.value += Number(res.data[i].reduceMoney)
          integralDeduct.value += Number(res.data[i].integralDeduct)
          voucherDeduct.value += Number(res.data[i].voucherDeduct)
          res.data[i].total =  Number(res.data[i].cash) + Number(res.data[i].incomeVirtual) +Number(res.data[i].bankMoney) +Number(res.data[i].alipayMoney) +Number(res.data[i].wechartMoney) +Number(res.data[i].groupMoney) + Number(res.data[i].shezhang) + Number(res.data[i].kdbScanPay)
        }
        for(let i = 0;i<res.data.length;i++){
          res.data[i].statisticTime = res.data[i].statisticTime.substring(0,10)
          res.data[i].cash = res.data[i].incomeCashMember + res.data[i].incomeCashOther
          res.data[i].total = res.data[i].discountMoney + res.data[i].freeMoney + res.data[i].reduceMoney + res.data[i].integralDeduct + res.data[i].voucherDeduct
          disMoney.value += Number(res.data[i].total)
        }
        dataOne.value = res.data
      } catch(err) {
        console.log(err)
      }
    }
    infoData()
    return{
      yearMonthArr,
      subNum,
      changeSubNum,
      dataOne,
      options1,
      options2,
      options3,
      input1,
      value1,
      value2,
      value3,
      headerStyle,cellStyle,
      discountMoney,
      freeMoney,
      reduceMoney,
      integralDeduct,
      voucherDeduct,
      disMoney,
    }
  }
}
</script>
<style scoped>
.vip-type-list{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #D9EFFF;
  height: 65px;
  margin-bottom: 10px;
}
.vip-type-list>span{
  display: flex;
  background-color: #D9EFFF;
  height: 65px;
  line-height: 65px;
  font-size: 16px;
  margin-left: 20px;
  font-weight: 600;
}


.date-box{
    width: 274px;
    height: 32px;
    margin-right: 20px;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(228, 228, 228, 1);
    border-radius: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.box-left{
  width: 30px;
  height: 25px;
  margin: 2.5px 0;
  border-right: 1px solid #b4b4b4;
  font-size: 16px;
  line-height: 25px;
  cursor: pointer;
}
.box-right{
  text-align: right;
  width: 30px;
  height: 25px;
  margin: 2.5px 0;
  font-size: 16px;
  line-height: 25px;
  border-left: 1px solid #b4b4b4;
  cursor: pointer;
}
</style>